import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem, flex } from '../../../core';

const modifiers = {
  inline: () => ({
    styles: `
      margin: 0 -${rem(4)};
      ${flex('row', 'flex-start', 'center')};
      button, a {
        margin: 0 ${rem(4)};
      }
    `,
  }),
  autoWidthButton: () => ({
    styles: `
      button, a {
        width: auto;
      }
    `,
  }),
};

const ButtonGroupStyled = styled.div.attrs({
  className: 'component__buttonGroup',
})`
  button, a {
    margin: 0 0 ${rem(13)};
  }
  ${applyStyleModifiers(modifiers)};
`;

export default ButtonGroupStyled;
